import React from 'react'
import ControlledModal from './ControlledModal'
import { Button } from '../ui/button'
import { useCloseHireRequestMutation } from '../../reactWrapper/Redux/apiSlice'
import { toast } from 'react-toastify'

const CloseJobModal = ({open, closeModal, data}) => {
  const [closeHireRequest, { isLoading }] = useCloseHireRequestMutation();

  const handleCloseJob = async () => {
    try {
      await closeHireRequest(data.id).unwrap();
      toast.success("Job closed successfully");
      closeModal();
    } catch (error) {
      console.error("Failed to close job: ", error);
      toast.error(error?.data?.message || "Failed to close job");
    }
  }

  return (
    <div>

             <ControlledModal 
              open={open} 
              closeModal={closeModal}
              contentStyle={{ width: '400px', borderRadius: '12px', padding: '24px' }}
            >
              <div className="bg-white p-7 flex flex-col gap-10 rounded-lg">
      
     
       <h1>Are you sure you want to close <span className='font-bold text-black'>{data.jobTitle}</span> job?</h1>

       <div className='w-full flex items-center justify-end gap-3'>

              <Button 
                onClick={closeModal}
                className='text-sm inline-block rounded-lg border border-border
                py-[1px] px-[11.7px] text-muted-foreground'
              >
                Cancel
              </Button>

              <Button 
                onClick={handleCloseJob}
                disabled={isLoading}
                className='text-sm inline-block rounded-lg border border-border
               py-[1px] px-[11.7px] text-white bg-red-600'>
                {isLoading ? 'Closing...' : 'Close Job'}
              </Button>

       </div>
            
              </div>
            </ControlledModal> 
        
        </div>
  )
}

export default CloseJobModal